import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  FORGET_PASSWORD_RESEND,
  FORGET_PASSWORD_UPDATE,
  FORGET_PASSWORD_UPDATE_SUCCESS,
  FORGET_PASSWORD_UPDATE_ERROR,
  FORGOT_PASSWORD_RESET,
  RESET_FORGOT_PSWD_RESPONSE_MSG
} from "./actionTypes"

export const userForgetPassword = (user, history) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user, history },
  }
}
export const ResendForgotPassword = (user, history) => {
  return {
    type: FORGET_PASSWORD_RESEND,
    payload: { user, history },
  }
}
export const ForgotPasswordUpdate = (user, history) => {
  return {
    type: FORGET_PASSWORD_UPDATE,
    payload: { user, history },
  }
}

export const ForgotPasswordUpdateSuccess = message => {
  return {
    type: FORGET_PASSWORD_UPDATE_SUCCESS,
    payload: message,
  }
}
export const ForgotPasswordUpdateError = message => {
  return {
    type: FORGET_PASSWORD_UPDATE_ERROR,
    payload: message,
  }
}

export const userForgetPasswordSuccess = payload => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: payload,
  }
}

export const userForgetPasswordError = message => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: message,
  }
}

export const userForgetPasswordReset = message => {
  return {
    type: FORGOT_PASSWORD_RESET,
  }
}
export const resetForgotPswdResponseMsg = (payload) => {
  return {
    type: RESET_FORGOT_PSWD_RESPONSE_MSG,
    payload: payload,
  }
}
